const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20setting%20with%20dramatic%20red%20curtains%20and%20spotlight%2C%20dark%20moody%20atmosphere%2C%20mysterious%20silhouette%20on%20stage%2C%20cinematic%20lighting%20with%20warm%20amber%20tones%2C%20professional%20photography%20style%2C%20no%20people%20faces%20visible&width=800&height=500&seq=card-01-2026&orientation=landscape',
    tag: '网红爆料',
    title: '头部主播私密聊天记录遭泄露，人设崩塌引发全网热议',
    views: '128.6万',
    time: '2小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20scene%20with%20warm%20lighting%20and%20shadows%2C%20elegant%20dressing%20room%20with%20mirrors%20and%20vanity%20lights%2C%20mysterious%20atmosphere%2C%20entertainment%20industry%20aesthetic%2C%20dark%20red%20and%20gold%20color%20palette%2C%20no%20people%20visible&width=800&height=500&seq=card-02-2026&orientation=landscape',
    tag: '明星八卦',
    title: '某选秀出道艺人被前经纪人实名举报，涉嫌合同欺诈',
    views: '96.3万',
    time: '5小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20media%20control%20room%20with%20multiple%20screens%20displaying%20abstract%20content%2C%20dark%20environment%20with%20blue%20and%20red%20ambient%20glow%2C%20professional%20broadcast%20setting%2C%20cinematic%20style%20photography%2C%20no%20identifiable%20content%20on%20screens&width=800&height=500&seq=card-03-2026&orientation=landscape',
    tag: '深度扒皮',
    title: '知名MCN机构内部运营黑幕曝光，多名签约博主集体解约',
    views: '87.5万',
    time: '8小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Luxury%20event%20venue%20with%20elegant%20decorations%20and%20dramatic%20lighting%2C%20empty%20red%20carpet%20scene%20with%20velvet%20ropes%2C%20premium%20entertainment%20industry%20setting%2C%20warm%20golden%20and%20dark%20tones%2C%20cinematic%20photography&width=800&height=500&seq=card-04-2026&orientation=landscape',
    tag: '热门追踪',
    title: '综艺录制现场突发意外，选手与导师激烈对峙全程录像流出',
    views: '73.2万',
    time: '12小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20courtroom%20style%20setting%20with%20dramatic%20shadows%20and%20warm%20spotlight%2C%20legal%20documents%20on%20wooden%20table%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%20with%20rich%20contrast%2C%20no%20people&width=800&height=500&seq=card-05-2026&orientation=landscape',
    tag: '独家首发',
    title: '某平台千万粉丝大V被指数据造假，第三方审计报告疑流出',
    views: '65.8万',
    time: '1天前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20scenes%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20movie%20production%20environment%2C%20cinematic%20professional%20photography%2C%20no%20people&width=800&height=500&seq=card-06-2026&orientation=landscape',
    tag: '网红爆料',
    title: '美食博主被曝使用过期食材拍摄，品牌方紧急终止全部合作',
    views: '52.4万',
    time: '1天前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20trophy%20and%20dramatic%20lighting%2C%20dark%20background%20with%20golden%20accents%2C%20premium%20entertainment%20setting%2C%20cinematic%20photography%20with%20rich%20blacks%20and%20warm%20highlights%2C%20no%20people&width=800&height=500&seq=card-07-2026&orientation=landscape',
    tag: '明星八卦',
    title: '当红小生被曝学历造假，母校官方回应引发二次舆论风暴',
    views: '48.1万',
    time: '2天前',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            精选黑料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全网最受关注的黑料视频，海量正片在线播放等你来看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.map((item, i) => (
            <article
              key={i}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-snug mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="whitespace-nowrap">{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}